import React from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'react-router-dom';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Terms from '../components/Terms';
import * as Strings from '../constants';

export default () => (
  <div className="pageWrapper default">

      <Helmet>
        <title>{Strings.Page_Terms + " · " + Strings.Meta_PageTitle}</title>
      </Helmet>

   <Row>
      <Col md={4} className="pageTitle">
        <h1>{Strings.Page_Terms}</h1>
        <p className="explanation" dangerouslySetInnerHTML={{ __html: Strings.TermsExplanation }} />
        <Link to="framework">
          <button className="exploreFramework">{Strings.ExploreFramework}</button>
        </Link>
      </Col>
      <Col md={7}>
        <Terms selectedTerm="" />
      </Col>
    </Row>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/terms.js